import { Component, model, signal, computed } from '@angular/core';

import { GROUP_OPTIONS, GroupOption, GroupValue } from './group-option.interface';
import { GroupPopupComponent } from './group-popup/group-popup.component';

@Component({
  selector: 'app-group-dropdown',
  templateUrl: './group-dropdown.component.html',
  styleUrls: ['./group-dropdown.component.less'],
  standalone: true,
  imports: [GroupPopupComponent],
})
export class GroupDropdownComponent {
  // Signal models for component state
  readonly groupMode = model.required<GroupValue>();
  readonly isOpen = signal(false);
  readonly options = signal<readonly GroupOption[]>(GROUP_OPTIONS);

  // Computed properties
  readonly selectedLabel = computed(() => {
    const option = this.options().find(opt => opt.value === this.groupMode());
    return option ? option.label : '';
  });

  toggleDropdown(): void {
    this.isOpen.update(isOpen => !isOpen);
  }

  onSelect(option: GroupOption): void {
    this.groupMode.set(option.value);
    this.isOpen.set(false);
  }

  onPopupClose(): void {
    this.isOpen.set(false);
  }
}
